import { ListItem, Breadcrumb, ListFilter, ListSorter, ListTabHeader, ListContentType, ListSort, ListContentTypeRequest } from './lists';
import { MyStuffFeatureContent } from './mystuff';

export enum WatchlistWPSTypes {
    WatchlistItem = 'atv.wps#WatchlistItem'
}

export interface WatchlistItem extends ListItem {
    isPrime: boolean;
    showSash: boolean;
    __type: WatchlistWPSTypes.WatchlistItem
}

export interface WatchlistStrings {
    removed: string;
    seeMore: string;
}

export interface WatchlistPrimeToggle {
    label: string;
    altText: string;
    suffix: string;
    applied: boolean;
    onHref: string;
    offHref: string;
}

export interface WatchlistOutput extends MyStuffFeatureContent {
    landmark: Breadcrumb;
    filters: ListFilter[];
    primeToggle?: WatchlistPrimeToggle;
    sorter?: ListSorter;
    content: ListContentType;
    strings: WatchlistStrings;
    tabHeaders?: ListTabHeader[];
    debug?: object;
}

export interface WatchlistArgs {
    startIndex?: number;
    sort: ListSort;
    contentType: ListContentTypeRequest;
    primeOnly: boolean;
}
